"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapListDTO = exports.MapDTO = void 0;
class MapDTO {
}
exports.MapDTO = MapDTO;
class MapListDTO {
}
exports.MapListDTO = MapListDTO;
//# sourceMappingURL=Map.js.map